import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { Button } from '../../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Label } from '../../ui/label';
import { Country, regexType } from "../../sharedfiles/helper";
import { getFinancials } from "../primaryplayer/PrimaryPlayerSlice";
import {
  getAddManualList,
  getPaymentHistorytableList,
  getWithdrawBonus,
  setIsVisisble,
  setShowPayments,
} from "./paymentHistoryTableSlice";
import { manualDropdown } from "../Common/data/mapData";
import { COMMON_CONSTANTS, MANUALDIALOG_CONSTANTS } from "../../sharedfiles/Constants";
import Tooltips from "../Common/Tooltip";
import { Payments } from "../../sharedfiles/tooltipMsgs";
import { Switch } from "../../ui/switch";
const ManualDialog = (props) => {
  const { status, DialogClose } = props;
  const dispatch = useDispatch();
  const [amount, setAmount] = useState("");
  const [userMsg, setUserMsg] = useState("");
  const [adjustmentType, setAdjustmentType] = useState("");
  const [payment, setPayment] = useState("");
  const [wallet, setWallet] = useState("")
  const [allocation, setAllocation] = useState("")
  const [toggle, setToggle] = useState(false)
  const [isToggled, setIsToggle] = useState("");
  const [errors, setErrors] = useState({
    amount: "",
    adjustmentType: "",
    payment: "",
    comments: "",
    wallet: "",
    allocation: ""
  });

  const financialData = useSelector((state) => state.primaryplayer.financialData);
  const manualToggle = useSelector((state) => state.dashboard.manualToggle);
  const mvDepositManual = useSelector((state) => state.dashboard.mvDepositManual)

  const setErrorHandler = (name, val, msg) => {
    setErrors((prevState) => {
      return {
        ...prevState,
        [name]: val === "" ? msg : "",
      };
    });
  };
  const handleAmount = (e) => {
    const { name, value } = e.target;
    let regex = regexType.oneDecimal;
    if (value === "" || regex.test(value)) {
      setAmount(value);
    }
    setErrorHandler(name, value, "Please enter valid Amount");
  };
  const handleDdl = (e) => {
    const { name, value } = e.target;
    if (name === "adjustmentType") {
      setAdjustmentType(value);
      setErrorHandler(name, value, "Please enter valid Type");
    } else {
      setPayment(value);
      setErrorHandler(name, value, "Please enter valid Operation");
    }

  };

  const walletDdl = (e) => {
    const { name, value } = e.target;
    if (name === "wallet") {
      setWallet(value)
      setErrorHandler(name, value, "Please enter valid Wallet Type");
    } else {
      setPayment(value);
      setErrorHandler(name, value, "Please enter valid Operation");
    }
  }

  const bonusHandle = (e) => {
    const { name, value } = e.target;
    if (name === "allocation") {
      setAllocation(value)
      setErrorHandler(name, value, "Please enter valid Bonus Type");
    }
    else {
      setPayment(value);
      setErrorHandler(name, value, "Please enter valid Operation");
    }
  }

  const toggled = (e) => {
    setIsToggle(!isToggled)
    isToggled ? setToggle(false) : setToggle(true)

  }
  const handleMessage = (e) => {
    const { value } = e.target;
    setUserMsg(value);
    setErrorHandler("comments", value, "Please enter valid Comments");
  };
  const avaliableBalance = () => {
    let condition = false;
    const balance =
      Object.keys(financialData).length > 0 &&
      financialData.playerSummaryVw?.withdrawls;
    const available = Number(Math.floor(balance / 100));
    // if (payment === "WITHDRAW" && amount > available) {
    //   condition = true;
    // }
    return condition;
  };
  const formValidation = () => {
    let isValid = true;
    if (amount === "") {
      setErrorHandler("amount", amount, "Please enter valid Amount");
      isValid = false;
    }
    if (adjustmentType === "") {
      setErrorHandler("adjustmentType", adjustmentType, "Please enter valid Type");
      isValid = false;
    }
    if (payment === "") {
      setErrorHandler("payment", payment, "Please enter valid Operation");
      isValid = false;
    }
    if (3 > userMsg.trim().length) {
      setErrorHandler("comments", userMsg, "Please enter valid Comments");
      isValid = false;
    }
    if (payment === "WITHDRAW" && wallet === "") {
      setErrorHandler("wallet", wallet, "Please enter valid Wallet Type");
      isValid = false;
    }

    if (wallet === "BONUSBALANCE" && allocation === "") {
      setErrorHandler("allocation", allocation, "Please enter valid Bonus Type");
      isValid = false;
    }
    avaliableBalance() && (isValid = false);
    return isValid;
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (avaliableBalance()) {
      setErrorHandler("amount", "", "Insufficient Funds");
    } else {
      var playerserachdata = {
        amount: amount,
        adjustmentType: adjustmentType,
        paymentType: payment,
        description: userMsg,
        status: status,
        offlinePayment: false,
        addToWithdrawBucket: toggle,
        // wallet: wallet,
      };
      var isValid = formValidation();
      if (isValid) {
        dispatch(getFinancials({ user_id: localStorage.getItem("userId") }));
        dispatch(getFinancials({ user_id: localStorage.getItem("userId") }));
        dispatch(
          getAddManualList(localStorage.getItem("userId"), playerserachdata)
        );
        DialogClose();
        setTimeout(() => {
          dispatch(setShowPayments(true));
        }, 2000);
        dispatch(setIsVisisble(false));
        setTimeout(() => {
          dispatch(
            getPaymentHistorytableList(0, 25, {
              id: localStorage.getItem("userId"),
            })
          );
        }, 1000);
      }
    }

  };

  const realBalance = () => {
    const userId = localStorage.getItem("userId")
    var isValid = formValidation();
    const data = {
      amount: amount,
      adjustmentType: adjustmentType,
      paymentType: payment,
      description: userMsg,
      offlinePayment: false,
    }
    if (isValid) {
      dispatch(getFinancials({ user_id: localStorage.getItem("userId") }));
      dispatch(getFinancials({ user_id: localStorage.getItem("userId") }));
      dispatch(
        getAddManualList(localStorage.getItem("userId"), data)
      );
      DialogClose();
      setTimeout(() => {
        dispatch(setShowPayments(true));
      }, 2000);
      dispatch(setIsVisisble(false));
      setTimeout(() => {
        dispatch(
          getPaymentHistorytableList(0, 25, {
            id: userId,
          })
        );
      }, 1000);
    }
  }

  const withdrawSubmit = () => {
    const userId = localStorage.getItem("userId")
    console.log(userId, "user")
    var isValid = formValidation();
    var payload = {
      amount: Number(amount),
      transactionType: adjustmentType,
      userId: userId,
      withdrawalBonus: allocation
    }
    
    if (isValid) {
      dispatch(getFinancials({ user_id: localStorage.getItem("userId") }));
      dispatch(getFinancials({ user_id: localStorage.getItem("userId") }));
      dispatch(
        getWithdrawBonus(payload)
      );
      DialogClose();
      setTimeout(() => {
        dispatch(setShowPayments(true));
      }, 2000);
      dispatch(setIsVisisble(false));
      setTimeout(() => {
        dispatch(
          getPaymentHistorytableList(0, 25, {
            id: userId,
          })
        );
      }, 1000);
    }
  }
  const errorStyles = {
    color: "red",
    marginTop: "-13px",
    marginBottom: "20px",
  };
  return (
    <div className="space-y-6">
      <div className="space-y-4">
        {/* Operation Field */}
        <div className="space-y-2">
          <Label htmlFor="payment" className="text-sm font-semibold flex items-center gap-2">
            {MANUALDIALOG_CONSTANTS.operation}
            <Tooltips info={Payments.Operation} />
          </Label>
          <Select value={payment || undefined} onValueChange={(value) => handleDdl({ target: { name: 'payment', value } })}>
            <SelectTrigger id="payment" className={errors.payment ? "border-red-500" : ""}>
              <SelectValue placeholder={COMMON_CONSTANTS.ddlOpt_select} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value='MANUAL_CREDIT'>{COMMON_CONSTANTS.deposit}</SelectItem>
              <SelectItem value='MANUAL_DEBIT'>{COMMON_CONSTANTS.withDraw}</SelectItem>
              {mvDepositManual && <SelectItem value='MV_CREDIT_TO_WTH_AMT'>{COMMON_CONSTANTS.MV_DEPOSIT_TO_WTH_AMT}</SelectItem>}
            </SelectContent>
          </Select>
          {errors.payment && <div className="text-sm text-red-500">{errors.payment}</div>}
        </div>

        {/* Wallet Field */}
        {payment === "MANUAL_DEBIT" && (
          <div className="space-y-2">
            <Label htmlFor="wallet" className="text-sm font-semibold flex items-center gap-2">
              {MANUALDIALOG_CONSTANTS.wallet}
              <Tooltips info={Payments.manual_wallet} />
            </Label>
            <Select value={wallet || undefined} onValueChange={(value) => walletDdl({ target: { name: 'wallet', value } })}>
              <SelectTrigger id="wallet" className={errors.wallet ? "border-red-500" : ""}>
                <SelectValue placeholder={COMMON_CONSTANTS.ddlOpt_select} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value='REALBALANCE'>{MANUALDIALOG_CONSTANTS.ddlOpt_realBalance}</SelectItem>
                <SelectItem value='BONUSBALANCE'>{MANUALDIALOG_CONSTANTS.ddlOpt_bonusBalance}</SelectItem>
              </SelectContent>
            </Select>
            {errors.wallet && <div className="text-sm text-red-500">{errors.wallet}</div>}
          </div>
        )}

        {/* Bonus Allocation Field */}
        {payment !== "MANUAL_CREDIT" && wallet === "BONUSBALANCE" && (
          <div className="space-y-2">
            <Label htmlFor="allocation" className="text-sm font-semibold">
              {MANUALDIALOG_CONSTANTS.bonus_allocation}
            </Label>
            <Select value={allocation || undefined} onValueChange={(value) => bonusHandle({ target: { name: 'allocation', value } })}>
              <SelectTrigger id="allocation" className={errors.allocation ? "border-red-500" : ""}>
                <SelectValue placeholder={COMMON_CONSTANTS.ddlOpt_select} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value='unlocked'>{MANUALDIALOG_CONSTANTS.ddlOpt_unlockedBonus}</SelectItem>
                <SelectItem value='locked'>{MANUALDIALOG_CONSTANTS.ddlOpt_lockedBonus}</SelectItem>
              </SelectContent>
            </Select>
            {errors.allocation && <div className="text-sm text-red-500">{errors.allocation}</div>}
          </div>
        )}

        {/* Adjustment Type Field */}
        <div className="space-y-2">
          <Label htmlFor="adjustmentType" className="text-sm font-semibold flex items-center gap-2">
            {MANUALDIALOG_CONSTANTS.header_type}
            <Tooltips info={Payments.manual_Type} />
          </Label>
          <Select value={adjustmentType || undefined} onValueChange={(value) => handleDdl({ target: { name: 'adjustmentType', value } })}>
            <SelectTrigger id="adjustmentType" className={errors.adjustmentType ? "border-red-500" : ""}>
              <SelectValue placeholder={COMMON_CONSTANTS.ddlOpt_select} />
            </SelectTrigger>
            <SelectContent>
              {manualDropdown.map((item, index) => {
                return (
                  (payment === "MANUAL_CREDIT" && item.isDeposit) ||
                    (payment === "MANUAL_DEBIT" && !item.isDeposit && !item.isMvDeposit) ||
                    (payment === "MV_CREDIT_TO_WTH_AMT" && item.isMvDeposit) ?
                    <SelectItem key={index} value={item.value}>{item.name}</SelectItem> :
                    null
                );
              })}
            </SelectContent>
          </Select>
          {errors.adjustmentType && <div className="text-sm text-red-500">{errors.adjustmentType}</div>}
        </div>

        {/* Amount Field */}
        <div className="space-y-2">
          <Label htmlFor="amount" className="text-sm font-semibold flex items-center gap-2">
            {COMMON_CONSTANTS.th_amount}
            <Tooltips info={Payments.Amount} />
          </Label>
          <Input
            id="amount"
            name='amount'
            type='text'
            placeholder='Enter amount'
            onChange={handleAmount}
            value={amount}
            className={errors.amount ? "border-red-500" : ""}
          />
          {errors.amount && <div className="text-sm text-red-500">{errors.amount}</div>}
        </div>
        {/* Comments Field */}
        <div className="space-y-2">
          <Label htmlFor="comments" className="text-sm font-semibold flex items-center gap-2">
            {COMMON_CONSTANTS.header_comment}
            <Tooltips info={Payments.manual_comment} />
          </Label>
          <Textarea
            id="comments"
            onChange={handleMessage}
            value={userMsg}
            rows={3}
            name='comments'
            maxLength={70}
            placeholder="Enter comments (minimum 3 characters)"
            className={errors.comments ? "border-red-500" : ""}
          />
          {errors.comments && <div className="text-sm text-red-500">{errors.comments}</div>}
        </div>
      </div>

      {/* Toggle Section */}
      {manualToggle && payment === "MANUAL_CREDIT" && (
        <div className="flex items-center justify-between p-4 rounded-lg border bg-muted/50">
          <Label htmlFor="toggleActive" className="text-sm font-medium cursor-pointer">
            {MANUALDIALOG_CONSTANTS.add_withdrwable_balance}
          </Label>
          <Switch
            id='toggleActive'
            checked={isToggled}
            onCheckedChange={toggled}
          />
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex justify-end gap-3 pt-4 border-t">
        {wallet === "BONUSBALANCE" ?
          <Button
            onClick={withdrawSubmit}
            type='button'
            variant="default"
          >
            {COMMON_CONSTANTS.save}
          </Button>
          : wallet === "REALBALANCE" ?
            <Button
              onClick={realBalance}
              type='button'
              variant="default"
            >
              {COMMON_CONSTANTS.save}
            </Button> :
            <Button
              onClick={submitHandler}
              type='button'
              variant="default"
            >
              {COMMON_CONSTANTS.save}
            </Button>}
      </div>
    </div>
  );
};

export default ManualDialog;
